import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { TestimonialeHero } from '../components/testimoniale/TestimonialeHero';
import { TestimonialeVideos } from '../components/testimoniale/TestimonialeVideos';
import { TestimonialeWritten } from '../components/testimoniale/TestimonialeWritten';
import { TestimonialeFinalCTA } from '../components/testimoniale/TestimonialeFinalCTA';
export function TestimonialePage() {
  return <div className="w-full bg-brand-cream font-body text-brand-text" data-id="element-2409">
      <Header data-id="element-2410" />
      <main data-id="element-2411">
        <TestimonialeHero data-id="element-2412" />
        <TestimonialeVideos data-id="element-2413" />
        <TestimonialeWritten data-id="element-2414" />
        <TestimonialeFinalCTA data-id="element-2415" />
      </main>
      <Footer data-id="element-2416" />
    </div>;
}